import GameSelect from '@components/BaseComponents/Select/GameSelect.vue';
import RegionSelect from '@components/BaseComponents/Select/RegionSelect.vue';

Vue.component('game-select', GameSelect);
Vue.component('region-select', RegionSelect);
